import React, { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import Platform from 'platform';
import keys from 'config/keys';
import useModals from 'hooks/useModals';

const mapStateToProps = ({ modal, overlay, loader, epg }) => ({
  isSomeOverlayOpen: !!modal.modalType || overlay.show || loader.isLoading || epg.isVisible,
});

export default function withBackSupport(WrappedComponent) {
  const WithBackSupport = (props) => {
    const { isSomeOverlayOpen } = props;
    const history = useHistory();
    const { showExitModal } = useModals();

    const onKeydown = useCallback(
      (e) => {
        if (isSomeOverlayOpen || e.keyCode !== Platform.getKeyCode(keys.BACK)) return;
        e.preventDefault();
        const isHomePage = ['/', '/screen/home'].includes(history.location.pathname);

        if (isHomePage) {
          // we know that home page has a custom collection
          showExitModal({ sectionToFocus: `@CUSTOM_COLLECTION` });
        } else {
          history.goBack();
        }
      },
      [history, isSomeOverlayOpen, showExitModal],
    );

    useEffect(() => {
      document.addEventListener('keydown', onKeydown, true);
      return () => document.removeEventListener('keydown', onKeydown, true);
    }, [onKeydown]);

    return <WrappedComponent {...props} />;
  };

  return connect(mapStateToProps)(WithBackSupport);
}
